export class CustomHubComponent {
  public title: string;
  public slug: string;
  public component: any;
}
